import { getRouteApi } from "@tanstack/react-router"
import { useStore } from "zustand"
import { createStore } from "zustand/vanilla"

type WeeksMessage = {
  tone: "success" | "error"
  text: string
}

type WeeksUiState = {
  // Mutation feedback for transition actions (shared between existing weeks table + manual form)
  transitionMessage: WeeksMessage | null

  // Per-row transition pending — only the clicked row is disabled
  pendingTransitionWeekId: string | null

  setTransitionMessage: (message: WeeksMessage | null) => void
  setPendingTransitionWeekId: (id: string | null) => void
}

export const createWeeksUiStore = () =>
  createStore<WeeksUiState>((set) => ({
    transitionMessage: null,
    pendingTransitionWeekId: null,

    setTransitionMessage: (message) => set({ transitionMessage: message }),
    setPendingTransitionWeekId: (id) => set({ pendingTransitionWeekId: id }),
  }))

export type WeeksUiStore = ReturnType<typeof createWeeksUiStore>

// Selector hooks
export const useTransitionMessage = (store: WeeksUiStore) =>
  useStore(store, (s) => s.transitionMessage)

export const usePendingTransitionWeekId = (store: WeeksUiStore) =>
  useStore(store, (s) => s.pendingTransitionWeekId)

// Route-scoped access
const weeksRouteApi = getRouteApi("/_authed/_admin/guild-war/weeks")

export const useWeeksRouteStore = () =>
  weeksRouteApi.useRouteContext({
    select: (ctx) => ctx.weeksStore,
  })
